const LedgerMockup = () => (
  <svg viewBox='0 0 400 220' className='w-full h-full' role='img' aria-label='Ledger SaaS billing dashboard mockup'>
    <defs>
      <linearGradient id='ledger-bg' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stopColor='#1f1f38' />
        <stop offset='55%' stopColor='#2c2c6c' />
        <stop offset='100%' stopColor='#4db5ff' />
      </linearGradient>
    </defs>
    <rect width='400' height='220' fill='url(#ledger-bg)' />

    <rect x='0' y='0' width='96' height='220' fill='#000' opacity='0.15' />
    {[0, 1, 2, 3].map((i) => (
      <rect key={i} x='20' y={28 + i * 30} width='56' height='9' rx='3' fill='#fff' opacity={i === 0 ? 0.9 : 0.35} />
    ))}

    <rect x='118' y='22' width='120' height='12' rx='4' fill='#fff' opacity='0.9' />
    <rect x='260' y='20' width='120' height='30' rx='8' fill='#4db5ff' opacity='0.9' />
    <rect x='276' y='28' width='60' height='8' rx='3' fill='#1f1f38' />

    <g transform='translate(118, 56)'>
      <rect width='120' height='64' rx='12' fill='#fff' opacity='0.08' />
      <rect x='14' y='14' width='60' height='8' rx='3' fill='#fff' opacity='0.6' />
      <rect x='14' y='30' width='80' height='14' rx='4' fill='#4db5ff' />
    </g>
    <g transform='translate(250, 56)'>
      <rect width='130' height='64' rx='12' fill='#fff' opacity='0.08' />
      <rect x='14' y='14' width='60' height='8' rx='3' fill='#fff' opacity='0.6' />
      <polyline points='14,48 34,36 54,42 74,24 94,32 114,18' fill='none' stroke='#4db5ff' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
    </g>

    <g transform='translate(118, 132)'>
      <rect width='262' height='66' rx='12' fill='#fff' opacity='0.06' />
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <rect key={i} x={16 + i * 40} y={50 - (10 + (i % 3) * 12)} width='18' height={10 + (i % 3) * 12} rx='3' fill='#4db5ff' opacity='0.8' />
      ))}
    </g>
  </svg>
)

export default LedgerMockup
